import {
  Box,
  Button,
  CircularProgress,
  Stack,
  Typography,
} from '@mui/material';
import CommonlandsLogoColorful from 'components/Icons/CommonlandsLogoColorful';
import { getAuth, RecaptchaVerifier } from 'firebase/auth';
import MuiPhoneNumber from 'material-ui-phone-number';
import { app } from 'pages/DeleteUser/firebase';
import React, { useEffect, useState } from 'react';
import { verifyPhone } from 'rest_client/publicUserClient';

const auth = getAuth(app);

const GetPin = ({
  setPhoneNumber,
  phoneNumber,
  setStep,
  setLoading: _onLoading,
  onSendVerificationCode,
  step,
}) => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [phoneCode, setPhoneCode] = useState('');

  useEffect(() => {
    window.recaptchaVerifier = new RecaptchaVerifier(auth, 'sign-in-button', {
      size: 'invisible',
      callback: (response) => {
        // reCAPTCHA solved, allow signInWithPhoneNumber.
        // sendVerificationCode();
      },
    });
  }, []);

  const onClick = async () => {
    if (phoneNumber === '') {
      setError('Phone number is required');
      return;
    }

    setLoading(true);
    // const confirmation = await auth().signInWithPhoneNumber(newPhone, resend);

    try {
      const { data } = await verifyPhone(phoneNumber);
      if (data?.isBanned) {
        throw new Error('This account has been banned');
      }
      if (!data?.isPhoneRegistered) {
        throw new Error('Phone number is not registered');
      }
      if (!data.isActive) {
        throw new Error('Account is not active');
      }
      await onSendVerificationCode();
      setStep(1);
    } catch (error) {
      console.log('error', error);
      setError(typeof error === 'string' ? error : error?.message);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (_onLoading) {
      _onLoading(loading);
    }
    return () => {
      if (_onLoading) {
        _onLoading(false);
      }
    };
  }, [loading]);

  return (
    <Stack
      flexDirection={'column'}
      gap={'10px'}
      justifyContent={'center'}
      position={step === 0 ? '' : 'absolute'}
      sx={{
        opacity: step === 0 ? 1 : 0,
      }}
    >
      <Box mx={'auto'}>
        <CommonlandsLogoColorful />
      </Box>
      <Typography
        textAlign={'center'}
        fontWeight={'600'}
        fontSize={'24px'}
        mt={'10px'}
      >
        Login
      </Typography>
      <Typography textAlign={'center'} mb={'20px'}>
        Enter the phone number associated with your account, and we’ll send you
        a verification code to log in
      </Typography>
      <Box>
        <Typography fontWeight={700}>Phone Number</Typography>
        <MuiPhoneNumber
          defaultCountry={'ug'}
          // defaultCountry={defaultCode}
          onChange={(value, { countryCode, dialCode, ...others }) => {
            setError(null);
            setPhoneNumber(value);
            setPhoneCode(dialCode);
          }}
          sx={phoneNumberSx}
          value={phoneNumber}
          autoFormat={false}
          countryCodeEditable={false}
          variant="outlined"
          placeholder="Enter the phone number of user"
          disabled={loading}
        />
      </Box>
      {error && <Typography color={'red'}>{error}</Typography>}
      <Button
        sx={{
          background: 'linear-gradient(90.69deg, #5FC4AC 5.99%, #3477BD 90.2%)',
          color: 'white',
          height: '50px',
          borderRadius: '12px',
          mt: 2,
        }}
        id="sign-in-button"
        onClick={onClick}
        disabled={phoneNumber.length <= phoneCode.length || loading}
      >
        {loading ? <CircularProgress size={25} /> : 'Get Pin'}
      </Button>
    </Stack>
  );
};

export default GetPin;

const phoneNumberSx = {
  width: '100%',
  '& .MuiOutlinedInput-root': {
    borderRadius: '8px',
  },
  '& svg': { height: '1em' },
};
